import * as z from "zod/v4";
import { ItemSchema } from "./common/item-schema";

export const calculateNewOrderFromReturn = {
  name: "calculateNewOrderFromReturn" as const,
  method: "unary" as const,
  input: z.object({
    returnId: z.string(),
    exchangeItems: z.array(
      z.object({
        variantId: z.string(),
        productId: z.string().optional(),
        quantity: z.number().int().positive(),
      }),
    ),
    customer: z
      .object({
        id: z.string().optional(),
        email: z.string().optional(),
        shippingAddress: z.any().optional(),
      })
      .optional(),
  }),
  output: z.object({
    newOrderInfo: z
      .object({
        subtotal: z.number(),
        tax: z.number(),
        total: z.number(),
        shipping: z.number().optional(),
        items: z.array(ItemSchema),
        discounts: z.array(z.any()).optional(),
      })
      .nullable(),
  }),
};
